import { useContext, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import SearchInput from 'components/Form/TextField/SearchField.cmp';
import ListGridToggle from 'components/ListGridToggle';
import AddTemplateFolderDropdown from 'pages/Templates/MyTemplates/Header/addTemplateFolderDropdown/addTemplateFolderDropdown';
import { MyTemplatesContext } from 'pages/Templates/MyTemplates/myTemplatesContext.tsx/context';
import { HeaderCnt } from 'pages/Templates/MyTemplates/Header/style';
import { getItem, setItem } from 'utils/globalFunction';
import { LOCALSTORAGE_KEYS } from 'utils/globalVariable';
import { useWorkspaceHook } from 'utils/CustomHooks/useWorkspaceHook';

function MyTemplatesHeader() {
  const { search } = useLocation();
  const { navigateWithWorkspaceUrl } = useWorkspaceHook();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const { state = {}, isArchive, updateState } = useContext(MyTemplatesContext);
  const { searchTerm } = state;
  const selectedView = state?.selectedView;
  const updateToggleHandler = (selectedView) => {
    setItem(LOCALSTORAGE_KEYS.TEMPLATES_SELECTED_VIEW, selectedView);
    updateState({ ...state, selectedView });
    navigateWithWorkspaceUrl(`/checklist?view=${selectedView}`);
  };
  const handleChangeSearch = (e) => {
    const searchTerm = e.target.value;
    updateState({ searchTerm });
  };

  useEffect(() => {
    const view = searchParams.get('view') ?? '';
    if (['list', 'grid'].includes(view)) {
      updateToggleHandler(view);
    }
    const selected = getItem(LOCALSTORAGE_KEYS.TEMPLATES_SELECTED_VIEW);
    if (selected) {
      updateState({ ...state, selectedView: selected });
    }
  }, [searchParams]);

  return (
    <HeaderCnt>
      <div className={'lefCnt'}>
        <SearchInput
          fieldProps={{
            value: searchTerm,
            onChange: (e) => handleChangeSearch(e),
          }}
          sx={{
            maxWidth: { sm: 'calc(100vw - 140px)', md: 250 },
            width: { sm: '100%', md: 350 },
          }}
        />
        {/*<SortByDropdown />*/}
      </div>
      <div className={'rightCnt'}>
        <ListGridToggle
          selectedView={selectedView}
          setSelectedView={updateToggleHandler}
        />
        {!isArchive && <AddTemplateFolderDropdown />}
      </div>
    </HeaderCnt>
  );
}

export default MyTemplatesHeader;
